export const onlyUnique = function (value, index, self) {
  return self.indexOf(value) === index;
};

export const unique = function (array) {
  if (!Array.isArray(array)) {
    return [];
  }
  return array.filter(onlyUnique);
};
